import script from "./Products.vue?vue&type=script&setup=true&lang=ts"
export * from "./Products.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__